module.exports = __webpack_public_path__ + "a8f8519444ad397cc6f0854972a090cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PFDinTextPro-Bold.ttf
// module id = 47
// module chunks = 0